"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeResponseDto = exports.ReportingToDto = exports.StatusDto = exports.VerticalDto = exports.IworkRoleDto = exports.BranchDto = exports.SalutationDto = exports.OrganizationDto = exports.DesignationDto = exports.DepartmentDto = exports.LocationDto = exports.RoleDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
class RoleDto {
}
exports.RoleDto = RoleDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], RoleDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Admin" }),
    tslib_1.__metadata("design:type", String)
], RoleDto.prototype, "name", void 0);
class LocationDto {
}
exports.LocationDto = LocationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], LocationDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "New York" }),
    tslib_1.__metadata("design:type", String)
], LocationDto.prototype, "name", void 0);
class DepartmentDto {
}
exports.DepartmentDto = DepartmentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], DepartmentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Sales" }),
    tslib_1.__metadata("design:type", String)
], DepartmentDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Sales Department" }),
    tslib_1.__metadata("design:type", String)
], DepartmentDto.prototype, "description", void 0);
class DesignationDto {
}
exports.DesignationDto = DesignationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], DesignationDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Engineer" }),
    tslib_1.__metadata("design:type", String)
], DesignationDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Engineer Description" }),
    tslib_1.__metadata("design:type", String)
], DesignationDto.prototype, "description", void 0);
class OrganizationDto {
}
exports.OrganizationDto = OrganizationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], OrganizationDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "IIRM Kenya" }),
    tslib_1.__metadata("design:type", String)
], OrganizationDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "A leading provider of technology solutions and services.",
    }),
    tslib_1.__metadata("design:type", String)
], OrganizationDto.prototype, "description", void 0);
class SalutationDto {
}
exports.SalutationDto = SalutationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], SalutationDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Mr." }),
    tslib_1.__metadata("design:type", String)
], SalutationDto.prototype, "lookUpValue", void 0);
class BranchDto {
}
exports.BranchDto = BranchDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], BranchDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "IIRM Kenya" }),
    tslib_1.__metadata("design:type", String)
], BranchDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "A leading provider of technology solutions and services.",
    }),
    tslib_1.__metadata("design:type", String)
], BranchDto.prototype, "description", void 0);
class IworkRoleDto {
}
exports.IworkRoleDto = IworkRoleDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], IworkRoleDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Manager" }),
    tslib_1.__metadata("design:type", String)
], IworkRoleDto.prototype, "lookUpValue", void 0);
class VerticalDto {
}
exports.VerticalDto = VerticalDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], VerticalDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "IIRM Kenya" }),
    tslib_1.__metadata("design:type", String)
], VerticalDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "A leading provider of technology solutions and services.",
    }),
    tslib_1.__metadata("design:type", String)
], VerticalDto.prototype, "description", void 0);
class StatusDto {
}
exports.StatusDto = StatusDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], StatusDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Active" }),
    tslib_1.__metadata("design:type", String)
], StatusDto.prototype, "lookUpValue", void 0);
class ReportingToDto {
}
exports.ReportingToDto = ReportingToDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], ReportingToDto.prototype, "employeeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "John" }),
    tslib_1.__metadata("design:type", String)
], ReportingToDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Doe" }),
    tslib_1.__metadata("design:type", String)
], ReportingToDto.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "john.doe@example.com" }),
    tslib_1.__metadata("design:type", String)
], ReportingToDto.prototype, "emailId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "+1234567890" }),
    tslib_1.__metadata("design:type", String)
], ReportingToDto.prototype, "mobile", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], ReportingToDto.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "EMP_001" }),
    tslib_1.__metadata("design:type", String)
], ReportingToDto.prototype, "iirmEmpId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: RoleDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "role", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: LocationDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "location", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: DepartmentDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: DesignationDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: OrganizationDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "organization", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: SalutationDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: BranchDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "branch", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: IworkRoleDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "iworkRole", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: VerticalDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "vertical", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: StatusDto }),
    tslib_1.__metadata("design:type", Object)
], ReportingToDto.prototype, "status", void 0);
class EmployeeResponseDto {
}
exports.EmployeeResponseDto = EmployeeResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], EmployeeResponseDto.prototype, "employeeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "John" }),
    tslib_1.__metadata("design:type", String)
], EmployeeResponseDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Doe" }),
    tslib_1.__metadata("design:type", String)
], EmployeeResponseDto.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "john.doe@example.com" }),
    tslib_1.__metadata("design:type", String)
], EmployeeResponseDto.prototype, "emailId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "+1234567890" }),
    tslib_1.__metadata("design:type", String)
], EmployeeResponseDto.prototype, "mobile", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], EmployeeResponseDto.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "EMP_001" }),
    tslib_1.__metadata("design:type", String)
], EmployeeResponseDto.prototype, "iirmEmpId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: RoleDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "role", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: LocationDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "location", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: DepartmentDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: DesignationDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: OrganizationDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "organization", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: ReportingToDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "reportingTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: [ReportingToDto] }),
    tslib_1.__metadata("design:type", Array)
], EmployeeResponseDto.prototype, "reportees", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: SalutationDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: BranchDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "branch", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: IworkRoleDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "iworkRole", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: VerticalDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "vertical", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: StatusDto }),
    tslib_1.__metadata("design:type", Object)
], EmployeeResponseDto.prototype, "status", void 0);
